import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import Seo from '@components/Seo'
import { useStore } from '@Store/'
import { setHeaderColor, setShowHeaderBackground } from '@Store/'
import { colors } from '@styles/vars/colors.style'
import Hero from '@components/_AboutUs/Hero'
import OurMissionList from '@components/_AboutUs/OurMissionList'
import OurMissionInfo from '@components/_AboutUs/OurMissionInfo'
import OurMissionGrid from '@components/_AboutUs/OurMissionGrid'
import OurModelInfo from '@components/_AboutUs/OurModelInfo'
import OurModelSideBySide from '@components/_AboutUs/OurModelSideBySide'
import OurToolsSideBySide from '@components/_AboutUs/OurToolsSideBySide'
import OurTeamInfo from '@components/_AboutUs/OurTeamInfo'
import OurLeaderShip from '@components/_AboutUs/OurLeaderShip'
import Beast from '@components/_AboutUs/Beast'
import PageFooter from '@components/_AboutUs/PageFooter'
import Brands from '@components/_AboutUs/Brands'
import Quote from '@components/_Service/Quote'

const AboutUsNew = ({ data }) => {
  const [, dispatch] = useStore()
  const {
    seo,
    slug,
    backgroundVideo,
    backgroundPlaceholder,
    featuredTitle,
    heroList,
    ourMissionTitle,
    ourMissionList,
    ourMissionBackground,
    ourMissionBackgroundPlaceholder,
    ourMissionMainInfo,
    ourMissionSideBySideList,
    ourMissionSideBySideTitle,
    ourMissionSideBySideSubTitle,
    ourModelTitle,
    ourModelMainInfo,
    ourModelBackground,
    ourModelList,
    ourToolsTitle,
    ourToolsMainInfo,
    ourToolsBackground,
    ourToolsList,
    ourToolsLinks,
    ourTeamImage,
    ourTeamTitle,
    ourLeadership,
    beastList,
    ourClients,
    quotes,
    footer,
  } = data.contentfulAboutUsNew

  useEffect(() => {
    setHeaderColor(dispatch, colors.white, colors.charcoal)
    setShowHeaderBackground(dispatch,true);
  }, [dispatch])

  const footerContent = {
    ...footer,
    backgroundColour: colors.pastelYellow,
    textColour: colors.green,
  }

  return (
    <>
      <Seo data={seo} slug={slug} />

      <Hero video={backgroundVideo} image={backgroundPlaceholder} title={featuredTitle} list={heroList}/>

      <OurMissionList subTitle={ourMissionTitle} list={ourMissionList} video={ourMissionBackground} placeholder={ourMissionBackgroundPlaceholder} />

      <OurMissionInfo list={ourMissionMainInfo} />

      <OurMissionGrid items={ourMissionSideBySideList} title={ourMissionSideBySideTitle} subTitle={ourMissionSideBySideSubTitle}/>

      <OurModelInfo title={ourModelTitle} content={ourModelMainInfo} background={ourModelBackground} id="our-model" sectionTitle={<><span>Our</span><strong>model</strong></>}/>
      
      <OurModelSideBySide list={ourModelList} />

      <OurModelInfo title={ourToolsTitle} content={ourToolsMainInfo} background={ourToolsBackground} id="our-tools-and-technology" sectionTitle={<><span>Our</span><strong>tools & technology</strong></>}/>

      <OurToolsSideBySide list={ourToolsList} links={ourToolsLinks}/>
      

      <OurLeaderShip list={ourLeadership}/>

      <Beast list={beastList} />
      
      <Brands items={ourClients} />

      <Quote content={quotes} />

      <PageFooter content={footer} />
    </>
  )
}

export default AboutUsNew

export const pageQuery = graphql`
  query AboutUsNew($slug: String!) {
    contentfulAboutUsNew(slug: { eq: $slug }) {
      seo {
        ...SEO
      }
      slug
      backgroundVideo {
        ...Image
      }
      backgroundPlaceholder {
        ...Image
      }
      featuredTitle {
        raw
      }
      heroList {
        text {
          raw
        }
        url
      }
      ourMissionTitle
      ourMissionList {
        text {
          raw
        }
      }
      ourMissionBackgroundPlaceholder {
        ...Image
      }
      ourMissionMainInfo {
        text {
          raw
        }
      }
      ourMissionSideBySideList {
        textOld {
          textOld
        }
        text {
          raw
        }
        image {
          ...Image
        }
      }
      ourMissionSideBySideSubTitle {
        raw
      }
      ourMissionSideBySideTitle {
        raw
      }
      ourModelTitle {
        raw
      }
      ourModelMainInfo {
        raw
      }
      ourModelBackground {
        ...Image
      }
      ourModelList {
        textOld {
          textOld
        }
        text {
          raw
          references {
            ...References
          }
        }
        subText {
          raw
        }
        url
      }
      ourToolsTitle {
        raw
        references {
          ...References
        }
      }
      ourToolsMainInfo {
        raw
      }
      ourToolsBackground {
        ...Image
      }
      ourToolsList {
        text {
          raw
        }
        image {
          ...Image
        }
      }
      ourToolsLinks {
        textOld {
          textOld
        }
        image {
          ...Image
        }
        url
      }
      ourTeamTitle {
        raw
      }
      ourTeamImage {
        ...Image
      }
      ourLeadership {
        name
        image {
          gatsbyImageData(height: 350, width: 350)
          description
        }
        role
        linkedInUrl
      }
      beastList {
        textOld {
          textOld
        }
        text {
          raw
        }
      }
      ourClients {
        ...Image
      }
      quotes {
        quoteContent {
          raw
        }
        image {
          ...Image
        }
        authorName
        authorDescription {
          authorDescription
        }
      }
      footer {
        ...PageFooter
      }
    }
  }
`
